import { storeRoutes } from './appRoutes.Stores'
import { moySkladRoutes } from './appRoutes.MoySklad'
import { moySkladAppRouteBase, moySkladAppRoutes } from './appRoutes.MoySkladApp'

import { createRoute } from './routeUtils'

import { MoySkladAppScreenParams } from '../types/moySkladAppTypes'
import { IntegrationTypeKey, StoreIntegrationType } from '../types/integrationTypeUtils'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { MoySkladAppType } from '../server/mpsklad_common/MoySkladAppType'

export const appAuthRoutes = {
  Login: '/login',
  Register: '/register',
  PasswordReset: '/password-reset',
  MoySkladApp: createRoute<typeof MoySkladAppType, MoySkladAppScreenParams>({
    appType: MoySkladAppType
  }, moySkladAppRouteBase)`/${'appType'}`,
  /** Only for backwards compatibility */
  MoySkladAppOld: moySkladAppRouteBase
} as const

export const appRoutes = {
  ...storeRoutes,
  ...moySkladRoutes,
  ...moySkladAppRoutes,
  Account: '/account',
  AdminUsers: '/admin/users',
  AdminMsAppLifecycle: '/admin/ms-app-lifecycle',
  AdminRealizationReports: '/admin/realization-reports',
  Diffs: '/diffs'
} as const

export const isMoySkladAppRoute = () =>
  // TODO: Use router's method?
  window.location.pathname.toLowerCase().startsWith(moySkladAppRouteBase.toLowerCase())

/**
 * This type is for "in" params - when creating a route or URL.
 */
export type IntegrationRouteParams =
  RouteParamsConstraint<{
    integration: IntegrationTypeKey
    accountId: number
  }>

/**
 * This type is for "out" params - when getting them from router-dom hooks.
 * Must be parsed and validated.
 */
export type IntegrationHookParams =
  HookParamsConstraint<{
    integration?: IntegrationTypeKey
    accountId?: string
  }>

/**
 * This type is for the parsed params from our routing hooks.
 */
export type IntegrationParams =
  Readonly<{
    integration: IntegrationType
    accountId: number
  }>

/**
 * This type is for the parsed params from our routing hooks.
 */
export type StoreRouteParams =
  Readonly<{
    integration: StoreIntegrationType
    accountId: number
  }>

export type RouteParamValue = number | string

/**
 * Route params must satisfy this constraint.
 */
export type RouteParamsConstraint<T> =
  T extends Record<string, RouteParamValue> ? T : never

/**
 * Params from router's hooks must satisfy this constraint.
 */
export type HookParamsConstraint<T> =
  T extends Record<string, string> ? T : never